import { render } from "./CustomerReport.vue?vue&type=template&id=5c4cc914&scoped=true&ts=true"
import script from "./CustomerReport.vue?vue&type=script&lang=ts"
export * from "./CustomerReport.vue?vue&type=script&lang=ts"

import "./CustomerReport.vue?vue&type=style&index=0&id=5c4cc914&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4cc914"]])

export default __exports__